import { c as _c } from "react/compiler-runtime";
import { WebVitalsLabProps } from './shared';
import { InpTracker } from './inp';
import { LcpTracker } from './lcp';
const TrackerModule = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <><InpTracker {...props} /><LcpTracker {...props} /></>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default TrackerModule;